import React, { Component } from "react";
import AspectButton from "../DeckBuilderComponents/FilterComponents/AspectButton";
import novablitz_full from '../DeckBuilderComponents/novablitz_full.json';
import novacardtext from '../DeckBuilderComponents/cardtext.json';
import _ from 'lodash';
import forEach from 'lodash/forEach';
import difference from 'lodash/difference';
import CardGalleryV2 from "./CardGalleryV2";
import * as firebasedb from "../firebase/firebase";
import { Button, Form, FormGroup, Label, Input, Collapse } from 'reactstrap';



class FiltersV2 extends Component {

  constructor(props, context) {
  super(props, context);

  this.state = {
    search: "",
    cardType:"None",
    rarity:"None",
    subType:"None",
    filteredCards: [],
    keyWord:"None",
    arcaneActive: false,
    chaosActive: false,
    divineActive: false,
    natureActive: false,
    technologyActive: false,
    display: "none"
  };

    this.filter = this.filter.bind(this);
    this.searchChange = this.searchChange.bind(this);
    this.cardTypeChange = this.cardTypeChange.bind(this);
    this.subTypeChange = this.subTypeChange.bind(this);
    this.rarityChange = this.rarityChange.bind(this);
    this.keyWordChange = this.keyWordChange.bind(this);
    this.filterCards = this.filterCards.bind(this);
    this.filterCardSet = this.filterCardSet.bind(this);
    this.filterRarity = this.filterRarity.bind(this);
    this.filterCardType = this.filterCardType.bind(this);
    this.filterCardText = this.filterCardText.bind(this);
    this.filterSubtypeName = this.filterSubtypeName.bind(this);
    this.filterSubType = this.filterSubType.bind(this);
    this.filterKeyWord = this.filterKeyWord.bind(this);
    this.arcaneClicked = this.arcaneClicked.bind(this);
    this.chaosClicked = this.chaosClicked.bind(this);
    this.divineClicked = this.divineClicked.bind(this);
    this.natureClicked = this.natureClicked.bind(this);
    this.technologyClicked = this.technologyClicked.bind(this);
    this.filterAspect = this.filterAspect.bind(this);
  }

  searchChange(event) {
    this.setState({search: event.target.value})
  }

  cardTypeChange(event) {
    this.setState({cardType: event.target.value})
  }

  rarityChange(event) {
    this.setState({rarity: event.target.value})
  }

  subTypeChange(event) {
    this.setState({subType: event.target.value})
  }

  keyWordChange(event) {
    this.setState({keyWord: event.target.value})
  }

  arcaneClicked(event){
    if (this.state.arcaneActive){
      this.setState({ arcaneActive: false })
    } else {
      this.setState({ arcaneActive: true})
    }
  }

  chaosClicked(event){
    if (this.state.chaosActive){
      this.setState({ chaosActive: false })
    } else {
      this.setState({ chaosActive: true})
    }
  }

  divineClicked(event){
    if (this.state.divineActive){
      this.setState({ divineActive: false })
    } else {
      this.setState({ divineActive: true})
    }
  }

  natureClicked(event){
    if (this.state.natureActive){
      this.setState({ natureActive: false })
    } else {
      this.setState({ natureActive: true})
    }
  }

  technologyClicked(event){
    if (this.state.technologyActive){
      this.setState({ technologyActive: false })
    } else {
      this.setState({ technologyActive: true})
    }
  }

  filter(event) {
        this.filterCards();
        this.setState({display:"block"})
        event.preventDefault();


  }


  filterCards() {
      var filteredCards = this.state.filteredCards;
      var filteredCardText = [];
      var filteredSearchSubtypeName = [];
      var filteredSearchCards = [];
      var filteredSearchDifference = [];
      var firstBy = require('thenby');
      var thenBy = require('thenby');

      filteredCardText = novacardtext.filter(this.filterCardText);

      _.forEach(novablitz_full.Cards, function (n, key) {
          _.forEach(filteredCardText, function (n2, key2) {
              if (n.CardId == n2.CardID) {
                  filteredSearchCards.push(n);
              }
          });
      });

      filteredSearchSubtypeName = novablitz_full.Cards.filter(this.filterSubtypeName);
      filteredSearchDifference = _.difference(filteredSearchSubtypeName, filteredSearchCards);


      filteredSearchDifference.forEach(function(n, key) {
          filteredSearchCards.push(n);
      });

      filteredCards = filteredSearchCards
          .filter(this.filterCardSet)
          .filter(this.filterAspect)
          .filter(this.filterSubType)
          .filter(this.filterCardType)
          .filter(this.filterKeyWord)
          .filter(this.filterRarity);

      filteredCards.sort(firstBy("Cost").thenBy("Name", { ignoreCase: true }));
      this.setState({filteredCards: filteredCards})
  }

  //Filter Logic
  filterAspect(card) {

      var arcaneSelected = this.state.arcaneActive;
      var chaosSelected = this.state.chaosActive;
      var divineSelected = this.state.divineActive;
      var natureSelected = this.state.natureActive;
      var technologySelected = this.state.technologyActive;

      if ( arcaneSelected || chaosSelected || divineSelected || natureSelected || technologySelected ) {
          return ((arcaneSelected && card.Aspect == "A")
              || (chaosSelected && card.Aspect == "C")
              || (divineSelected && card.Aspect == "D")
              || (natureSelected && card.Aspect == "N")
              || (technologySelected && card.Aspect == "T")
          );
      }
      else {return true; };
  };

  filterCardSet(card) {
      return card.CardSet != -1;
  }

  filterSubType(card) {
      var selectedSubType = this.state.subType;

      if (selectedSubType != "None") {
          return card.Subtype == selectedSubType;
      }
      else { return true; };
  }

  filterCardType(card) {
      var sCardType = this.state.cardType;
      if (sCardType != "None") {
          return ((sCardType == "Unit" && card.IsUnit == "true") || (sCardType == "Power" && card.IsPower == "true"));
      }
      else { return true; };
  }

  filterKeyWord(card) {
      var selectedKeyWord = this.state.keyWord;
      var keys= card.Keywords;
      if (selectedKeyWord != "None") {
          var bReturn = false;

          if ('Keywords' in card)
          Object.keys(card.Keywords).forEach(function (key){
              if (selectedKeyWord == key) {
                bReturn = true;
              }
          });

          return bReturn;
       }
      else { return true; };
  }

  filterRarity(card) {
      var selectedRarity = this.state.rarity;
      if (selectedRarity != "None") {
          return card.Rarity == selectedRarity;
      }
      else { return true; };
  }


  filterCardText(card) {
      var searchText = this.state.search.toUpperCase();
      return card.Text.toUpperCase().includes(searchText);

  };

  filterSubtypeName(card) {
      var searchText = this.state.search.toUpperCase();
      if (searchText.length > 0) {
          return (
              (
                  ("Subtype" in card) && card.Subtype.toUpperCase().includes(searchText)
                  || card.Name.toUpperCase().includes(searchText)
              )
          );
      }
      else { return true; };
  }

  render() {
    var filtersStyle = {
      backgroundColor:"slategray",
      justifyContent: "center",
      paddingTop:5
    };

    var buttonStyle = {

        color: "#fff",
        backgroundColor: "#495057",
        borderColor: "#6c757d"

    }

    return (
      <React.Fragment>

    <Collapse isOpen={this.props.isOpenF}>
      <Form inline style={filtersStyle} className="rounded">




        <FormGroup className="mb-2 mr-sm-2 mb-sm-2 mr-1 mb-md-2 mb-lg-2 mb-xl-2">
          <Label className="ml-2 mr-sm-2">Card Type</Label>
          <Input type="select" id="sCardType" value={this.state.cardType} onChange={this.cardTypeChange} bsSize="sm" >
              <option value="None"></option>
              <option value="Unit">Unit</option>
              <option value="Power">Power</option>
          </Input>
        </FormGroup>




        <FormGroup className="mb-2 mr-sm-2 mb-sm-2 mr-1  mb-md-2 mb-lg-2 mb-xl-2">
          <Label className="ml-2 mr-sm-2">SubType</Label>
          <Input type="select" id="sSubType" value={this.state.subType} onChange={this.subTypeChange} bsSize="sm" >
            <option value="None"></option>
            <option value="Aircraft">Aircraft</option>
            <option value="Angel">Angel</option>
            <option value="Archon">Archon</option>
            <option value="Barbarian">Barbarian</option>
            <option value="Beast">Beast</option>
            <option value="Construct">Construct</option>
            <option value="Cyborg">Cyborg</option>
            <option value="Demon">Demon</option>
            <option value="Djinn">Djinn</option>
            <option value="Druid">Druid</option>
            <option value="Dwarf">Dwarf</option>
            <option value="Egg">Egg</option>
            <option value="Elemental">Elemental</option>
            <option value="Elf">Elf</option>
            <option value="Explosive">Explosive</option>
            <option value="Fairy">Fairy</option>
            <option value="Giant">Giant</option>
            <option value="Goblin">Goblin</option>
            <option value="Hacker">Hacker</option>
            <option value="Illusion">Illusion</option>
            <option value="Knight">Knight</option>
            <option value="Kren">Kren</option>
            <option value="Merfolk">Merfolk</option>
            <option value="Minotaur">Minotaur</option>
            <option value="Monster">Monster</option>
            <option value="Ninja">Ninja</option>
            <option value="Ogre">Ogre</option>
            <option value="Orc">Orc</option>
            <option value="Priest">Priest</option>
            <option value="Robot">Robot</option>
            <option value="Shapeshifter">Shapeshifter</option>
            <option value="Soldier">Soldier</option>
            <option value="Steamlord">Steamlord</option>
            <option value="Tank">Tank</option>
            <option value="Unicorn">Unicorn</option>
            <option value="Vampire">Vampire</option>
            <option value="Witch">Witch</option>
            <option value="Wizard">Wizard</option>
            <option value="Zoa">Zoa</option>
            <option value="Zombie">Zombie</option>
          </Input>
        </FormGroup>



        <FormGroup className="mb-2 mr-sm-2 mb-sm-2 mr-1  mb-md-2 mb-lg-2 mb-xl-2">
          <Label className="ml-2 mr-sm-2">Key Word</Label>
          <Input type="select" id="sKeyWord" value={this.state.keyWord} onChange={this.keyWordChange} bsSize="sm" >
            <option value="None"></option>
            <option value="16">Activated Ability</option>
            <option value="19">Armor</option>
            <option value="11">Attack</option>
            <option value="15">Block</option>
            <option value="6">Cannot Block</option>
            <option value="21">Double Attack</option>
            <option value="35">Double Block</option>
            <option value="29">Evade</option>
            <option value="20">First Strike</option>
            <option value="23">Flying</option>
            <option value="41">Frenzy</option>
            <option value="14">Infilitrate</option>
            <option value="17">Initiative</option>
            <option value="13">Last Breath</option>
            <option value="38">Lifelink</option>
            <option value="26">Overrun</option>
            <option value="25">Regenerate</option>
            <option value="12">Summon</option>
            <option value="34">Unblockable</option>
            <option value="36">Vanguard</option>
          </Input>
        </FormGroup>



        <FormGroup className="mb-2 mr-sm-2 mb-sm-2 mr-1  mb-md-2 mb-lg-2 mb-xl-2">
          <Label className="ml-2 mr-sm-2">Rarity</Label>
          <Input  type="select" id="sRarity"  value={this.state.rarity} onChange={this.rarityChange} bsSize="sm">
              <option value="None"></option>
              <option value="C">Common</option>
              <option value="R">Rare</option>
              <option value="E">Epic</option>
              <option value="L">Legendary</option>
          </Input>
        </FormGroup>



        <FormGroup className="mb-2 mr-sm-2 mb-sm-2 mr-1  mb-md-2 mb-lg-2 mb-xl-2">
          <Label className="ml-2 mr-sm-2">Search</Label>
          <Input type="text" id="searchBox" value={this.state.search} onChange={this.searchChange} bsSize="sm" />
        </FormGroup>

        <FormGroup className="mb-2 mr-sm-2 mb-sm-2 mr-1  mb-md-2 mb-lg-2 mb-xl-2">
          <Label className="ml-2 mr-sm-2 mr-2">Aspect</Label>
          <div className="btn-group" role="group" aria-label="Basic example">
              <AspectButton aspectImage="Arcane" value="A" active={this.state.arcaneActive} clickHandler={this.arcaneClicked}/>
              <AspectButton aspectImage="Chaos" value="C" active={this.state.chaosActive} clickHandler={this.chaosClicked}/>
              <AspectButton aspectImage="Divine" value="D" active={this.state.divineActive} clickHandler={this.divineClicked}/>
              <AspectButton aspectImage="Nature" value="N" active={this.state.natureActive} clickHandler={this.natureClicked}/>
              <AspectButton aspectImage="Technology" value="T" active={this.state.technologyActive} clickHandler={this.technologyClicked}/>
          </div>
          <Button style={buttonStyle} onClick={this.filter} className="ml-2 mr-sm-2 mr-2" >Filter</Button>
        </FormGroup>



      </Form>
        </Collapse>
      <Collapse isOpen={this.props.isOpenCG}>
        <CardGalleryV2 cards={this.state.filteredCards} clickHandler={this.props.clickHandler} display={this.state.display} width={this.props.width}/>
      </Collapse>
      </React.Fragment>
    );
  }
}

export default FiltersV2;



// WEBPACK FOOTER //
// ./src/DBV2/FiltersV2.js